import { useEffect, useRef } from "react";
import { partners } from "@/mocks/home";

export default function TrustSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll(".animate-on-scroll");
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-14 md:py-20 bg-gradient-to-b from-background-100 to-background-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-heading">
            Ils nous font confiance
          </h2>
          <div className="w-24 h-1 bg-primary-500 mx-auto rounded-full"></div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-20">
          {partners.map((partner, index) => (
            <div
              key={partner.alt}
              className={`animate-on-scroll opacity-0 translate-y-6 transition-all duration-700 flex items-center justify-center hover:scale-105 transition-transform duration-300`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="w-full h-32 flex items-center justify-center">
                <a
                  href={partner.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full h-full flex items-center justify-center"
                >
                  <img
                    src={partner.image}
                    alt={partner.alt}
                    className="w-auto h-full object-contain hover:scale-110 transition-transform duration-300 cursor-pointer"
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}